// todo: require not working, find a way to import folder
import ad from '../../shared/images/flags/ad.svg';
import bl from '../../shared/images/flags/bl.svg';
import cv from '../../shared/images/flags/cv.svg';
import ga from '../../shared/images/flags/ga.svg';
import hr from '../../shared/images/flags/hr.svg';
import ky from '../../shared/images/flags/ky.svg';
import mq from '../../shared/images/flags/mq.svg';
import pg from '../../shared/images/flags/pg.svg';
import sk from '../../shared/images/flags/sk.svg';
import tw from '../../shared/images/flags/tw.svg';
import ae from '../../shared/images/flags/ae.svg';
import bm from '../../shared/images/flags/bm.svg';
import cw from '../../shared/images/flags/cw.svg';
import ht from '../../shared/images/flags/ht.svg';
import kz from '../../shared/images/flags/kz.svg';
import mr from '../../shared/images/flags/mr.svg';
import ph from '../../shared/images/flags/ph.svg';
import sl from '../../shared/images/flags/sl.svg';
import tz from '../../shared/images/flags/tz.svg';
import af from '../../shared/images/flags/af.svg';
import bn from '../../shared/images/flags/bn.svg';
import cx from '../../shared/images/flags/cx.svg';
import hu from '../../shared/images/flags/hu.svg';
import la from '../../shared/images/flags/la.svg';
import ms from '../../shared/images/flags/ms.svg';
import pk from '../../shared/images/flags/pk.svg';
import sm from '../../shared/images/flags/sm.svg';
import ua from '../../shared/images/flags/ua.svg';
import ag from '../../shared/images/flags/ag.svg';
import bo from '../../shared/images/flags/bo.svg';
import cy from '../../shared/images/flags/cy.svg';
import id from '../../shared/images/flags/id.svg';
import lb from '../../shared/images/flags/lb.svg';
import mt from '../../shared/images/flags/mt.svg';
import pl from '../../shared/images/flags/pl.svg';
import sn from '../../shared/images/flags/sn.svg';
import ug from '../../shared/images/flags/ug.svg';
import ai from '../../shared/images/flags/ai.svg';
import bq from '../../shared/images/flags/bq.svg';
import cz from '../../shared/images/flags/cz.svg';
import ie from '../../shared/images/flags/ie.svg';
import lc from '../../shared/images/flags/lc.svg';
import mu from '../../shared/images/flags/mu.svg';
import pm from '../../shared/images/flags/pm.svg';
import so from '../../shared/images/flags/so.svg';
import um from '../../shared/images/flags/um.svg';
import al from '../../shared/images/flags/al.svg';
import br from '../../shared/images/flags/br.svg';
import de from '../../shared/images/flags/de.svg';
import gb from '../../shared/images/flags/gb.svg';
import il from '../../shared/images/flags/il.svg';
import li from '../../shared/images/flags/li.svg';
import mv from '../../shared/images/flags/mv.svg';
import pn from '../../shared/images/flags/pn.svg';
import sr from '../../shared/images/flags/sr.svg';
import un from '../../shared/images/flags/un.svg';
import all from '../../shared/images/flags/all.svg';
import bs from '../../shared/images/flags/bs.svg';
import dj from '../../shared/images/flags/dj.svg';
import gd from '../../shared/images/flags/gd.svg';
import im from '../../shared/images/flags/im.svg';
import lk from '../../shared/images/flags/lk.svg';
import mw from '../../shared/images/flags/mw.svg';
import pr from '../../shared/images/flags/pr.svg';
import ss from '../../shared/images/flags/ss.svg';
import us from '../../shared/images/flags/us.svg';
import am from '../../shared/images/flags/am.svg';
import bt from '../../shared/images/flags/bt.svg';
import dk from '../../shared/images/flags/dk.svg';
import ge from '../../shared/images/flags/ge.svg';
import flag_in from '../../shared/images/flags/in.svg';
import lr from '../../shared/images/flags/lr.svg';
import mx from '../../shared/images/flags/mx.svg';
import ps from '../../shared/images/flags/ps.svg';
import st from '../../shared/images/flags/st.svg';
import uy from '../../shared/images/flags/uy.svg';
import ao from '../../shared/images/flags/ao.svg';
import bv from '../../shared/images/flags/bv.svg';
import dm from '../../shared/images/flags/dm.svg';
import gf from '../../shared/images/flags/gf.svg';
import io from '../../shared/images/flags/io.svg';
import ls from '../../shared/images/flags/ls.svg';
import my from '../../shared/images/flags/my.svg';
import pt from '../../shared/images/flags/pt.svg';
import sv from '../../shared/images/flags/sv.svg';
import uz from '../../shared/images/flags/uz.svg';
import aq from '../../shared/images/flags/aq.svg';
import bw from '../../shared/images/flags/bw.svg';
import flag_do from '../../shared/images/flags/do.svg';
import gg from '../../shared/images/flags/gg.svg';
import iq from '../../shared/images/flags/iq.svg';
import lt from '../../shared/images/flags/lt.svg';
import mz from '../../shared/images/flags/mz.svg';
import pw from '../../shared/images/flags/pw.svg';
import sx from '../../shared/images/flags/sx.svg';
import va from '../../shared/images/flags/va.svg';
import ar from '../../shared/images/flags/ar.svg';
import by from '../../shared/images/flags/by.svg';
import dz from '../../shared/images/flags/dz.svg';
import gh from '../../shared/images/flags/gh.svg';
import ir from '../../shared/images/flags/ir.svg';
import lu from '../../shared/images/flags/lu.svg';
import na from '../../shared/images/flags/na.svg';
import py from '../../shared/images/flags/py.svg';
import sy from '../../shared/images/flags/sy.svg';
import vc from '../../shared/images/flags/vc.svg';
import as from '../../shared/images/flags/as.svg';
import bz from '../../shared/images/flags/bz.svg';
import ec from '../../shared/images/flags/ec.svg';
import gi from '../../shared/images/flags/gi.svg';
import is from '../../shared/images/flags/is.svg';
import lv from '../../shared/images/flags/lv.svg';
import nc from '../../shared/images/flags/nc.svg';
import qa from '../../shared/images/flags/qa.svg';
import sz from '../../shared/images/flags/sz.svg';
import ve from '../../shared/images/flags/ve.svg';
import at from '../../shared/images/flags/at.svg';
import ca from '../../shared/images/flags/ca.svg';
import ee from '../../shared/images/flags/ee.svg';
import gl from '../../shared/images/flags/gl.svg';
import it from '../../shared/images/flags/it.svg';
import ly from '../../shared/images/flags/ly.svg';
import ne from '../../shared/images/flags/ne.svg';
import re from '../../shared/images/flags/re.svg';
import tc from '../../shared/images/flags/tc.svg';
import vg from '../../shared/images/flags/vg.svg';
import au from '../../shared/images/flags/au.svg';
import cc from '../../shared/images/flags/cc.svg';
import eg from '../../shared/images/flags/eg.svg';
import gm from '../../shared/images/flags/gm.svg';
import je from '../../shared/images/flags/je.svg';
import ma from '../../shared/images/flags/ma.svg';
import nf from '../../shared/images/flags/nf.svg';
import ro from '../../shared/images/flags/ro.svg';
import td from '../../shared/images/flags/td.svg';
import vi from '../../shared/images/flags/vi.svg';
import aw from '../../shared/images/flags/aw.svg';
import cd from '../../shared/images/flags/cd.svg';
import eh from '../../shared/images/flags/eh.svg';
import gn from '../../shared/images/flags/gn.svg';
import jm from '../../shared/images/flags/jm.svg';
import mc from '../../shared/images/flags/mc.svg';
import ng from '../../shared/images/flags/ng.svg';
import rs from '../../shared/images/flags/rs.svg';
import tf from '../../shared/images/flags/tf.svg';
import vn from '../../shared/images/flags/vn.svg';
import ax from '../../shared/images/flags/ax.svg';
import cf from '../../shared/images/flags/cf.svg';
import er from '../../shared/images/flags/er.svg';
import gp from '../../shared/images/flags/gp.svg';
import jo from '../../shared/images/flags/jo.svg';
import md from '../../shared/images/flags/md.svg';
import ni from '../../shared/images/flags/ni.svg';
import ru from '../../shared/images/flags/ru.svg';
import tg from '../../shared/images/flags/tg.svg';
import vu from '../../shared/images/flags/vu.svg';
import az from '../../shared/images/flags/az.svg';
import cg from '../../shared/images/flags/cg.svg';
import gq from '../../shared/images/flags/gq.svg';
import jp from '../../shared/images/flags/jp.svg';
import me from '../../shared/images/flags/me.svg';
import nl from '../../shared/images/flags/nl.svg';
import rw from '../../shared/images/flags/rw.svg';
import th from '../../shared/images/flags/th.svg';
import wf from '../../shared/images/flags/wf.svg';
import ba from '../../shared/images/flags/ba.svg';
import ch from '../../shared/images/flags/ch.svg';
import es from '../../shared/images/flags/es.svg';
import gr from '../../shared/images/flags/gr.svg';
import ke from '../../shared/images/flags/ke.svg';
import mf from '../../shared/images/flags/mf.svg';
import no from '../../shared/images/flags/no.svg';
import sa from '../../shared/images/flags/sa.svg';
import tj from '../../shared/images/flags/tj.svg';
import ws from '../../shared/images/flags/ws.svg';
import bb from '../../shared/images/flags/bb.svg';
import ci from '../../shared/images/flags/ci.svg';
import et from '../../shared/images/flags/et.svg';
import gs from '../../shared/images/flags/gs.svg';
import kg from '../../shared/images/flags/kg.svg';
import mg from '../../shared/images/flags/mg.svg';
import np from '../../shared/images/flags/np.svg';
import sb from '../../shared/images/flags/sb.svg';
import tk from '../../shared/images/flags/tk.svg';
import xk from '../../shared/images/flags/xk.svg';
import bd from '../../shared/images/flags/bd.svg';
import ck from '../../shared/images/flags/ck.svg';
import eu from '../../shared/images/flags/eu.svg';
import gt from '../../shared/images/flags/gt.svg';
import kh from '../../shared/images/flags/kh.svg';
import mh from '../../shared/images/flags/mh.svg';
import nr from '../../shared/images/flags/nr.svg';
import sc from '../../shared/images/flags/sc.svg';
import tl from '../../shared/images/flags/tl.svg';
import ye from '../../shared/images/flags/ye.svg';
import be from '../../shared/images/flags/be.svg';
import cl from '../../shared/images/flags/cl.svg';
import fi from '../../shared/images/flags/fi.svg';
import gu from '../../shared/images/flags/gu.svg';
import ki from '../../shared/images/flags/ki.svg';
import mk from '../../shared/images/flags/mk.svg';
import nu from '../../shared/images/flags/nu.svg';
import sd from '../../shared/images/flags/sd.svg';
import tm from '../../shared/images/flags/tm.svg';
import yt from '../../shared/images/flags/yt.svg';
import bf from '../../shared/images/flags/bf.svg';
import cm from '../../shared/images/flags/cm.svg';
import fj from '../../shared/images/flags/fj.svg';
import gw from '../../shared/images/flags/gw.svg';
import km from '../../shared/images/flags/km.svg';
import ml from '../../shared/images/flags/ml.svg';
import nz from '../../shared/images/flags/nz.svg';
import se from '../../shared/images/flags/se.svg';
import tn from '../../shared/images/flags/tn.svg';
import za from '../../shared/images/flags/za.svg';
import bg from '../../shared/images/flags/bg.svg';
import cn from '../../shared/images/flags/cn.svg';
import fk from '../../shared/images/flags/fk.svg';
import gy from '../../shared/images/flags/gy.svg';
import kn from '../../shared/images/flags/kn.svg';
import mm from '../../shared/images/flags/mm.svg';
import om from '../../shared/images/flags/om.svg';
import sg from '../../shared/images/flags/sg.svg';
import to from '../../shared/images/flags/to.svg';
import zm from '../../shared/images/flags/zm.svg';
import bh from '../../shared/images/flags/bh.svg';
import co from '../../shared/images/flags/co.svg';
import fm from '../../shared/images/flags/fm.svg';
import hk from '../../shared/images/flags/hk.svg';
import kp from '../../shared/images/flags/kp.svg';
import mn from '../../shared/images/flags/mn.svg';
import pa from '../../shared/images/flags/pa.svg';
import sh from '../../shared/images/flags/sh.svg';
import tr from '../../shared/images/flags/tr.svg';
import zw from '../../shared/images/flags/zw.svg';
import bi from '../../shared/images/flags/bi.svg';
import cr from '../../shared/images/flags/cr.svg';
import fo from '../../shared/images/flags/fo.svg';
import hm from '../../shared/images/flags/hm.svg';
import kr from '../../shared/images/flags/kr.svg';
import mo from '../../shared/images/flags/mo.svg';
import pe from '../../shared/images/flags/pe.svg';
import si from '../../shared/images/flags/si.svg';
import tt from '../../shared/images/flags/tt.svg';
import bj from '../../shared/images/flags/bj.svg';
import cu from '../../shared/images/flags/cu.svg';
import fr from '../../shared/images/flags/fr.svg';
import hn from '../../shared/images/flags/hn.svg';
import kw from '../../shared/images/flags/kw.svg';
import mp from '../../shared/images/flags/mp.svg';
import pf from '../../shared/images/flags/pf.svg';
import sj from '../../shared/images/flags/sj.svg';
import tv from '../../shared/images/flags/tv.svg';

export const flags = {
    all,
    ad,
    bl,
    cv,
    ga,
    hr,
    ky,
    mq,
    pg,
    sk,
    tw,
    ae,
    bm,
    cw,
    ht,
    kz,
    mr,
    ph,
    sl,
    tz,
    af,
    bn,
    cx,
    hu,
    la,
    ms,
    pk,
    sm,
    ua,
    ag,
    bo,
    cy,
    id,
    lb,
    mt,
    pl,
    sn,
    ug,
    ai,
    bq,
    cz,
    ie,
    lc,
    mu,
    pm,
    so,
    um,
    al,
    br,
    de,
    gb,
    il,
    li,
    mv,
    pn,
    sr,
    un,
    bs,
    dj,
    gd,
    im,
    lk,
    mw,
    pr,
    ss,
    us,
    am,
    bt,
    dk,
    ge,
    in: flag_in,
    lr,
    mx,
    ps,
    st,
    uy,
    ao,
    bv,
    dm,
    gf,
    io,
    ls,
    my,
    pt,
    sv,
    uz,
    aq,
    bw,
    do: flag_do,
    gg,
    iq,
    lt,
    mz,
    pw,
    sx,
    va,
    ar,
    by,
    dz,
    gh,
    ir,
    lu,
    na,
    py,
    sy,
    vc,
    as,
    bz,
    ec,
    gi,
    is,
    lv,
    nc,
    qa,
    sz,
    ve,
    at,
    ca,
    ee,
    gl,
    it,
    ly,
    ne,
    re,
    tc,
    vg,
    au,
    cc,
    eg,
    gm,
    je,
    ma,
    nf,
    ro,
    td,
    vi,
    aw,
    cd,
    eh,
    gn,
    jm,
    mc,
    ng,
    rs,
    tf,
    vn,
    ax,
    cf,
    er,
    gp,
    jo,
    md,
    ni,
    ru,
    tg,
    vu,
    az,
    cg,
    gq,
    jp,
    me,
    nl,
    rw,
    th,
    wf,
    ba,
    ch,
    es,
    gr,
    ke,
    mf,
    no,
    sa,
    tj,
    ws,
    bb,
    ci,
    et,
    gs,
    kg,
    mg,
    np,
    sb,
    tk,
    xk,
    bd,
    ck,
    eu,
    gt,
    kh,
    mh,
    nr,
    sc,
    tl,
    ye,
    be,
    cl,
    fi,
    gu,
    ki,
    mk,
    nu,
    sd,
    tm,
    yt,
    bf,
    cm,
    fj,
    gw,
    km,
    ml,
    nz,
    se,
    tn,
    za,
    bg,
    cn,
    fk,
    gy,
    kn,
    mm,
    om,
    sg,
    to,
    zm,
    bh,
    co,
    fm,
    hk,
    kp,
    mn,
    pa,
    sh,
    tr,
    zw,
    bi,
    cr,
    fo,
    hm,
    kr,
    mo,
    pe,
    si,
    tt,
    bj,
    cu,
    fr,
    hn,
    kw,
    mp,
    pf,
    sj,
    tv
};
